module.exports = "/_next/static/videos/softball-1-89a8fcb06beb94c4311bde8f0b1b40ae.webm";